import { Component, OnDestroy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Event, NavigationCancel, NavigationEnd, NavigationError, ResolveEnd, ResolveStart, Router } from '@angular/router';

import { PrettyUrlsConfig } from '@frontend/sports/common/client-config-data-access';
import { HooksWireup, OnRouteResolve } from '@frontend/sports/common/core/utils/hooks';
import { AdaptiveLayoutService } from '@frontend/sports/layout/feature';
import { CustomLoadingIndicatorService, ILoadingIndicatorHandler } from '@frontend/sports/loading-indicator-feature';
import { HtmlNode } from '@frontend/vanilla/core';

import { IBetSlipRepositoryResult } from '../my-bets-base/models/my-bets-viewmodels';

@HooksWireup()
@Component({
    selector: 'ms-my-bets-route',
    templateUrl: 'my-bets-route.html',
    standalone: false,
})
export class MyBetsRouteComponent extends OnRouteResolve<IBetSlipRepositoryResult> implements OnDestroy {
    repositoryResult: IBetSlipRepositoryResult;
    isInitalLoadReady = false;
    private desktopIndicator: ILoadingIndicatorHandler | null = null;

    constructor(
        public override route: ActivatedRoute,
        public adaptiveLayout: AdaptiveLayoutService,
        private router: Router,
        private loadingIndicatorService: CustomLoadingIndicatorService,
        private urlConfig: PrettyUrlsConfig,
        private html: HtmlNode,
    ) {
        super(route);
        // TODO remove the code below when we have a global logic for loading indicator
        this.router.events.pipe(takeUntilDestroyed()).subscribe((routerEvent: Event) => {
            this.checkRouterEvent(routerEvent);
        });
    }

    onRouteResolved(loadedMyBetsData: IBetSlipRepositoryResult): void {
        this.repositoryResult = loadedMyBetsData;
        this.isInitalLoadReady = true;
    }

    checkRouterEvent(routerEvent: Event): void {
        if (this.isInitalLoadReady && routerEvent instanceof ResolveStart) {
            this.isInitalLoadReady = false;
            if (routerEvent.urlAfterRedirects.includes(this.urlConfig.translations.myBets)) {
                this.desktopIndicator = this.loadingIndicatorService.start('');
            }
        }
        if (
            !this.isInitalLoadReady &&
            (routerEvent instanceof ResolveEnd ||
                routerEvent instanceof NavigationEnd ||
                routerEvent instanceof NavigationCancel ||
                routerEvent instanceof NavigationError)
        ) {
            this.isInitalLoadReady = true;
            if (this.desktopIndicator) {
                this.desktopIndicator.done();
                this.desktopIndicator = null;
            }
        }
    }

    ngOnDestroy(): void {
        this.html.setCssClass('my-bets', false);
    }
}
